import { FormControl } from '@angular/forms';

export class RendererBuilder {
  constructor() {}

  buildViewAsPdfFormControl(viewableAsHtml: boolean) {
    return new FormControl({
      value: !viewableAsHtml,
      disabled: !viewableAsHtml,
    });
  }
}
